import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=e8967782&functional=true"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=e8967782&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports